export default __webpack_public_path__ + "static/16075-4e64469483884401fb6e2e824b246ebd.jpg";